import { render, staticRenderFns } from "./my-idea.vue?vue&type=template&id=7436405b&scoped=true"
import script from "./my-idea.vue?vue&type=script&lang=js"
export * from "./my-idea.vue?vue&type=script&lang=js"
import style0 from "./my-idea.vue?vue&type=style&index=0&id=7436405b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_c18e9a749cc21ff970a79c65ca01237d/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7436405b",
  null
  
)

export default component.exports